interface AppEvents {
  'capacitor::open': () => void
  'capacitor::close': () => void
  'capacitor::appUrlOpen': (event: { targetUrl: string }) => void
  'capacitor::resume': () => void
}

type Listener<K> = (payload: AppEvents[K]) => void

export class EventBus<T = AppEvents> {
  private listeners: { [K in keyof AppEvents]?: Set<Listener<AppEvents[K]>> } = {}

  on<K extends keyof AppEvents>(event: K, listener: Listener<AppEvents[K]>): void {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set()
    }

    this.listeners[event].add(listener)
  }

  off<K extends keyof AppEvents>(event: K, listener: Listener<AppEvents[K]>): void {
    this.listeners[event]?.delete(listener)
  }

  emit<K extends keyof AppEvents>(event: K, payload?: AppEvents[K]): void {
    this.listeners[event]?.forEach(fn => fn(payload))
  }
}

export const eventPluginKey = Symbol('events.bus')